import React from "react";
import { Link } from "react-router-dom";
import noData from "../../assets/images/noData.svg";
import { classNames } from "../../helpers/classNames";

const NoData = ({
  message = "No data available",
  image = noData,
  imageClass,
}) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className={classNames("w-64 h-64 overflow-hidden", imageClass)}>
        <img src={image} alt="no-data" />
      </div>
      <div className="text-center font-semibold text-deep-purple text-xl md:text-2xl">
        {message}
      </div>
    </div>
  );
};

export default NoData;
